import {useEffect} from 'react'
import {useNavigate} from 'react-router-dom'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useFetch from 'shared/model/useFetch'
import useLoginCookie from 'shared/model/useLoginCookie'
import useNameCookie from 'shared/model/useNameCookie'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const usePutAdminRole = (nameRef, pwRef) => {
	const navigate = useNavigate()
	const [fetchResult, fetchRequest] = useFetch()

	const [, , deleteLoginCookie] = useLoginCookie()
	const [userRole, , deleteRoleCookie] = useRoleCookie()
	const [, , deleteNameCookie] = useNameCookie()
	const [, setAlert] = useAlertModalAtom()
	const request = () => {
		const rolePath = getApiRolePath(userRole)
		let url = `/${rolePath}/my`

		fetchRequest('PUT', url, {
			password: pwRef.current?.value,
			name: nameRef.current?.value,
		})
	}

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 200:
				setAlert('내 정보를 수정하였습니다. 다시 로그인해주세요.')
				deleteLoginCookie()
				deleteRoleCookie()
				deleteNameCookie()
				break
		}
	}, [fetchResult])

	return [request]
}

export default usePutAdminRole
